// team/shared/components/button/TeamDarkButtonWithIcon.js
import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const TeamDarkButtonWithIcon = ({ text, onClick, icon, iconPosition = 'end', disabled = false, sx = {} }) => {
    const iconProps = {
        [`${iconPosition}Icon`]: icon
    };

    return (
        <Button
            variant="contained"
            onClick={onClick}
            disabled={disabled}
            {...iconProps}
            sx={{
                backgroundColor: '#000',
                color: '#fff',
                fontWeight: 700,
                borderRadius: '20px',
                textTransform: 'none',
                display: 'flex',
                alignItems: 'center',
                fontSize: '0.7rem',
                border: '1px solid #000',
                '&:hover': {
                    backgroundColor: '#000'
                },
                '&.Mui-disabled': {
                    backgroundColor: '#e0e0e0',
                    color: '#9e9e9e',
                    borderColor: '#e0e0e0'
                },
                '& .MuiButton-endIcon': {
                    marginLeft: '4px',
                    transform: iconPosition === 'end' ? 'scaleX(-1)' : 'none',
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px'  // Fixed icon size
                    }
                },
                '& .MuiButton-startIcon': {
                    marginRight: '4px',
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px'  // Fixed icon size
                    }
                },
                ...sx
            }}
        >
            {text}
        </Button>
    );
};

TeamDarkButtonWithIcon.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    icon: PropTypes.element,
    iconPosition: PropTypes.oneOf(['start', 'end']),
    disabled: PropTypes.bool,
    sx: PropTypes.object
};

export default TeamDarkButtonWithIcon;




